import { useSelector } from 'react-redux'
import { ReduxState } from '..'

const useUserInfo = () => useSelector((state: ReduxState) => state.userInfo)

export default useUserInfo
